import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ApiPaths } from "../../../../api/paths";
import CustomButton from "../../../../components/custom-button/CustomButton";
import DeleteIcon from "../../../../components/icons/DeleteIcon";
import useMutateData from "../../../../hooks/use-mutate-data";

type Props = {
  selectedItem: any;
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
};

export default function DeleteCartItem({
  show,
  onHide,
  onSuccess,
  selectedItem,
}: Props) {
  const { t } = useTranslation(["common", "components"]);
  const { mutate, loading: deleteLoading } = useMutateData(
    `${ApiPaths.cart}/${selectedItem?._id}`,
    {
      method: "DELETE",
      onError: () => {
        toast(t("cart.delete.error", { ns: "components" }), {
          type: "error",
          toastId: "cart-delete",
        });
      },
      onSuccess: () => {
        toast(t("cart.delete.success", { ns: "components" }), {
          type: "success",
        });
        onSuccess();
        onHide();
      },
    }
  );
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center d-flex flex-column align-items-center p-5">
        <h2 className="primary-modal-title modal-danger-title mb-4">
          {t("cart.delete.heading", { ns: "components" })}
        </h2>
        <div className="cancel-policy-icon-cont delete-icon-cont rounded-circle mb-4">
          <DeleteIcon />
        </div>
        <p className="mb-4">
          {t("cart.delete.message", {
            ns: "components",
          })}
          {` ` + selectedItem?._id}
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <button
            className="modal-primary-button modal-secondary-button me-4"
            onClick={onHide}
          >
            {t("button.cancel", { ns: "common" })}
          </button>
          <CustomButton
            className="modal-primary-button"
            onClick={() => mutate()}
            loading={deleteLoading}
          >
            {t("button.confirm", { ns: "common" })}
          </CustomButton>
        </div>
      </Modal.Body>
    </Modal>
  );
}
